/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CartItemOptionDto
 */
export interface CartItemOptionDto {
    /**
     * 
     * @type {string}
     * @memberof CartItemOptionDto
     */
    optionId: string;
    /**
     * 
     * @type {number}
     * @memberof CartItemOptionDto
     */
    quantity: number;
}

/**
 * Check if a given object implements the CartItemOptionDto interface.
 */
export function instanceOfCartItemOptionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "optionId" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function CartItemOptionDtoFromJSON(json: any): CartItemOptionDto {
    return CartItemOptionDtoFromJSONTyped(json, false);
}

export function CartItemOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartItemOptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optionId': json['optionId'],
        'quantity': json['quantity'],
    };
}

export function CartItemOptionDtoToJSON(value?: CartItemOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optionId': value.optionId,
        'quantity': value.quantity,
    };
}

